/**
 * File navigation.js.
 */
(function () {

    const scrollTopBtn = document.getElementById('contact-modal-btn');
    window.addEventListener('scroll', () => {
        if (window.scrollY > 200) {
            document.body.classList.add('has-sticky-header');
            document.body.classList.remove('has-sticky-header-animate-out');
            document.body.classList.add('has-sticky-header-animate-in');
        } else {
            document.body.classList.remove('has-sticky-header-animate-in');
            document.body.classList.add('has-sticky-header-animate-out');
            document.body.classList.remove('has-sticky-header');
        }

        if (scrollTopBtn) {
            const height = window.innerHeight
                || document.documentElement.clientHeight
                || document.body.clientHeight;

            if (window.scrollY > height) {
                scrollTopBtn.classList.remove('hidden');
            } else {
                scrollTopBtn.classList.add('hidden');
            }
        }
    });

    document.querySelectorAll('.menu-btn').forEach((menu) => {
        menu.addEventListener('click', () => {
            document.body.classList.toggle('mobile-menu-open');
            if (document.body.classList.contains('mobile-menu-open')) {
                document.body.classList.add('mobile-menu-open--animate-open');
                setTimeout(() => {
                    document.body.classList.remove('mobile-menu-open--animate-open');
                }, 1000);
            } else {
                document.body.classList.add('mobile-menu-open--animate-close');
                setTimeout(() => {
                    document.body.classList.remove('mobile-menu-open--animate-close');
                }, 1000);
            }
        });
    });

}());
